import { FC, useState } from 'react';
import { Box, Paper } from '@mui/material';
import ConcernsList from './components/ConcernsList.view';
import ConcernThreadView from './components/ConcernThreadView.view';
import { useGetConcernsHook, useGetConcernThreadHook } from '../../hooks/useConcernsHook';
import { Concern } from '../../../../../apis/messaging/messaging.interfaces';

interface ConcernsViewProps {
  isGuardian?: boolean;
  studentId?: string;
  onRaiseConcern?: () => void;
}

const ConcernsView: FC<ConcernsViewProps> = ({
  isGuardian = false,
  studentId,
  onRaiseConcern,
}) => {
  const [selectedConcern, setSelectedConcern] = useState<Concern | null>(null);

  const { data: concerns = [], isLoading } = useGetConcernsHook();
  const { data: threadData, isLoading: isLoadingThread } = useGetConcernThreadHook(
    selectedConcern?._id || selectedConcern?.id || null
  );

  const filteredConcerns = isGuardian && studentId
    ? concerns.filter(
        (c) => c.concern_metadata?.student_id === studentId
      )
    : concerns;

  return (
    <Box
      sx={{
        height: 'calc(100vh - 200px)',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        bgcolor: 'grey.100',
        borderRadius: { xs: 0, sm: 1 },
        overflow: 'hidden',
        px: { xs: 0, sm: 1 },
        py: { xs: 1, sm: 0 },
      }}
      data-testid="concerns-view"
    >
      <Paper
        elevation={0}
        sx={{
          width: { xs: '100%', md: '35%' },
          minWidth: { xs: 'auto', md: 300 },
          maxWidth: { xs: '100%', md: 400 },
          height: { xs: '40%', md: '100%' },
          display: 'flex',
          flexDirection: 'column',
          borderRight: { xs: 0, md: 1 },
          borderBottom: { xs: 1, md: 0 },
          borderColor: 'divider',
          borderRadius: { xs: 0, sm: 1 },
        }}
        data-testid="concerns-list-container"
      >
        <ConcernsList
          concerns={filteredConcerns}
          selectedConcernId={selectedConcern?._id || selectedConcern?.id || null}
          onSelectConcern={setSelectedConcern}
          onRaiseConcern={onRaiseConcern || (() => {})}
          isLoading={isLoading}
          isGuardian={isGuardian}
        />
      </Paper>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: { xs: '60%', md: '100%' },
        }}
        data-testid="concern-thread-container"
      >
        <ConcernThreadView
          concern={selectedConcern}
          threadData={threadData ?? null}
          isLoading={isLoadingThread}
          isStaff={!isGuardian}
        />
      </Box>
    </Box>
  );
};

export default ConcernsView;
